import { render, staticRenderFns } from "./InvoiceBody.vue?vue&type=template&id=b3de5a7c&scoped=true&"
import script from "./InvoiceBody.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBody.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceBody.vue?vue&type=style&index=0&id=b3de5a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de5a7c",
  null
  
)

export default component.exports